"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _SwPage = _interopRequireDefault(require("@/views/common/SwPage"));
var _user = require("@/api/auth/user");
var _org = require("@/api/auth/org");
var _addr = _interopRequireDefault(require("@/utils/addr"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var statusOptions = [{
  key: 0,
  display_name: '停用'
}, {
  key: 1,
  display_name: '正常'
}];
var statusKeyValue = statusOptions.reduce(function (acc, cur) {
  acc[cur.key] = cur.display_name;
  return acc;
}, {});
var _default = exports.default = {
  name: 'userIndex',
  directives: {
    waves: _waves.default
  },
  components: {
    SwPage: _SwPage.default
  },
  filters: {
    statusFilter: function statusFilter(key) {
      return statusKeyValue[key];
    }
  },
  computed: {},
  data: function data() {
    return {
      statusOptions: statusOptions,
      pList: null,
      cList: null,
      dList: null,
      addr: {
        provId: null,
        cityId: null,
        dictId: null,
        address: null
      },
      tableKey: 0,
      list: null,
      total: null,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 20,
        keywords: null,
        orgId: null
      },
      resTree: null,
      dialogResVisible: false,
      dialogFormVisible: false,
      dialogStatus: '',
      defaultProps: {
        children: 'children',
        label: 'roleName'
      },
      checkedKeys: [],
      textMap: {
        update: this.$t('buttons.Edit'),
        create: this.$t('buttons.Add')
      },
      isUpdate: false,
      midData: {
        //用户数据
        userId: null,
        username: null,
        password: null,
        //system: '0',
        email: null,
        mobile: null,
        status: '0',
        nickname: null
      },
      currentUserId: '',
      // 当前选中的用户ID
      rules: {
        // 请填写名称
        username: [{
          required: true,
          message: this.$t('placeholder.PleaseFillName'),
          trigger: 'blur'
        },
        // 字母数字横线,字母数字开头
        {
          pattern: /^[a-zA-Z0-9][a-zA-Z0-9_-]{1,10}$/,
          message: this.$t('placeholder.AlphanumericCharacter')
        }],
        // 请填写名称
        password: [{
          required: true,
          message: this.$t('placeholder.PleaseFillName'),
          trigger: 'blur'
        }],
        // 请输入正确的邮箱地址
        email: [{
          type: 'email',
          message: this.$t('placeholder.PleaseCoEmailAddr'),
          trigger: 'blur'
        }]
      },
      orgList: [] //组织列表
    };
  },
  created: function created() {
    var _this = this;
    if (this.$store.getters.orgGroup === 'ROOT') {
      this.getOrgList();
    }
    this.getList();
    (0, _addr.default)(0).then(function (response) {
      _this.pList = response;
    });
  },
  methods: {
    getOrgList: function getOrgList() {
      var _this2 = this;
      (0, _org.orgCombobox)().then(function (response) {
        if (response && response.data) {
          _this2.orgList = response.data.records;
        }
      });
    },
    getList: function getList() {
      var _this3 = this;
      this.listLoading = true;
      (0, _user.queryUserPage)(this.listQuery).then(function (response) {
        if (response) {
          _this3.list = response.records;
          _this3.total = response.total;
        }
        setTimeout(function () {
          _this3.listLoading = false;
        }, 0.5 * 1000);
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    retPage: function retPage() {
      //分页
      this.getList();
    },
    resetMidData: function resetMidData() {
      this.midData.userId = null;
      this.midData.username = null;
      this.midData.password = null;
      //this.midData.system =  0;
      this.midData.email = null;
      this.midData.mobile = null;
      this.midData.status = 0;
      this.midData.nickname = null;
    },
    handleCreate: function handleCreate() {
      var _this4 = this;
      this.resetMidData();
      this.isUpdate = false;
      this.dialogFormVisible = true;
      this.dialogStatus = 'create';
      this.$nextTick(function () {
        _this4.$refs['dataForm'].clearValidate();
      });
    },
    handleUpdate: function handleUpdate(row) {
      var _this5 = this;
      console.log(row);
      this.dialogFormVisible = true;
      this.resetMidData();
      this.isUpdate = true;
      this.dialogStatus = 'update';
      this.$nextTick(function () {
        _this5.$refs['dataForm'].clearValidate();
      });
      // 获取用户详情
      (0, _user.getUserById)(row.userId).then(function (response) {
        _this5.addr.provId = response.data.provCode;
        _this5.cList = response.cityList;
        _this5.addr.cityId = response.data.cityCode;
        _this5.dList = response.dictList;
        _this5.addr.dictId = response.data.dictCode;
        _this5.midData = response.data;
      });
    },
    updateUserRole: function updateUserRole() {
      var _this6 = this;
      // 全选和半选的全部传给后台
      var checkedKeys = this.$refs.resTree.getCheckedKeys(false).concat(this.$refs.resTree.getHalfCheckedKeys());
      var userRoleData = {
        userId: this.currentUserId,
        roleIdSet: checkedKeys
      };
      (0, _user.updateUserRole)(userRoleData).then(function () {
        _this6.dialogResVisible = false;
        _this6.getList();
        // 成功  更新成功
        _this6.$notify({
          title: _this6.$t('prompts.success'),
          message: _this6.$t('prompts.CreatedSucc'),
          type: 'success',
          duration: 3000
        });
        //重新加载数据
        _this6.getList();
      });
    },
    handleUserRole: function handleUserRole(row) {
      var _this7 = this;
      //加载组织树
      this.currentUserId = row.userId;
      // request -> /sysOrgUserRole/list
      (0, _user.getUserRoleTree)(row.userId).then(function (response) {
        _this7.resTree = response.data.list;
        if (response.data.roleSelectedList) {
          _this7.$refs.resTree.setCheckedKeys(response.data.roleSelectedList);
        }
      });
      this.dialogResVisible = true;
    },
    createData: function createData() {
      var _this8 = this;
      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          //this.midData.addr = this.addr;
          (0, _user.createUser)(_this8.midData).then(function () {
            _this8.dialogFormVisible = false;
            _this8.$notify({
              title: _this8.$t('prompts.success'),
              message: _this8.$t('prompts.CreatedSucc'),
              type: 'success',
              duration: 3000
            });
            //重新加载数据
            _this8.getList();
          });
        }
      });
    },
    updateData: function updateData() {
      var _this9 = this;
      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          _this9.midData.provCode = _this9.addr.provId;
          _this9.midData.cityCode = _this9.addr.cityId;
          _this9.midData.dictCode = _this9.addr.dictId;
          (0, _user.updateUser)(_this9.midData).then(function () {
            _this9.dialogFormVisible = false;
            _this9.$notify({
              title: _this9.$t('prompts.success'),
              message: _this9.$t('prompts.CreatedSucc'),
              type: 'success',
              duration: 3000
            });
            //重新加载数据
            _this9.getList();
          });
        }
      });
    },
    handleDelete: function handleDelete(row) {
      var _this0 = this;
      this.$confirm(this.$t("prompts.wantDelRecord"), this.$t("prompts.prompts"), {
        confirmButtonText: this.$t("buttons.Confirm"),
        cancelButtonText: this.$t("buttons.Cancel"),
        type: "warning"
      }).then(function () {
        var del = {
          userId: row.userId
        };
        (0, _user.deleteUser)(del).then(function () {
          _this0.$message({
            type: 'success',
            message: _this0.$t("prompts.DeletedSuc")
          });
          _this0.getList();
        });
      }).catch(function () {
        _this0.$message({
          type: 'info',
          message: _this0.$t("prompts.Cancelled")
        });
      });
    },
    closeUser: function closeUser(row) {
      var _this1 = this;
      this.$confirm(this.$t("prompts.wantDisableUser"), this.$t("prompts.prompts"), {
        confirmButtonText: this.$t("buttons.Confirm"),
        cancelButtonText: this.$t("buttons.Cancel"),
        type: "warning"
      }).then(function () {
        (0, _user.closeUser)(row.userId).then(function () {
          // 禁用成功
          _this1.$message({
            type: 'success',
            message: _this1.$t("prompts.DisSucc")
          });
          _this1.getList();
        });
      }).catch(function () {
        // 已取消
        _this1.$message({
          type: 'info',
          message: _this1.$t("prompts.Cancelled")
        });
      });
    },
    openUser: function openUser(row) {
      var _this10 = this;
      this.$confirm(this.$t("prompts.wantEnableUser"), this.$t("prompts.prompts"), {
        confirmButtonText: this.$t("buttons.Confirm"),
        cancelButtonText: this.$t("buttons.Cancel"),
        type: "warning"
      }).then(function () {
        (0, _user.openUser)(row.userId).then(function () {
          _this10.$message({
            type: 'success',
            message: _this10.$t("prompts.SucEnabled")
          });
          _this10.getList();
        });
      }).catch(function () {
        _this10.$message({
          type: 'info',
          message: _this10.$t("prompts.Cancelled")
        });
      });
    },
    //  地址
    selectProv: function selectProv(provId, selectCityId) {
      var _this11 = this;
      this.addr.cityId = null;
      this.addr.dictId = null;
      (0, _addr.default)(provId).then(function (response) {
        _this11.cList = response;
        _this11.addr.cityId = selectCityId;
      });
    },
    selectCity: function selectCity(cityId, selectDictId) {
      var _this12 = this;
      this.addr.dictId = null;
      (0, _addr.default)(cityId).then(function (response) {
        _this12.dList = response;
        _this12.addr.dictId = selectDictId;
      });
    },
    selectDict: function selectDict() {
      this.$forceUpdate();
    }
  }
};